  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        section.outerHTML = data['cart_content'];
        $s.globalEval(section);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
          //overlay reopened by updateCart()
          //$s.hideLoadingOverlay();
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = document.querySelector('header .cart-count');
  if(cartCountElement) {
    cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate(this.closest('.item'), 0);
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  if (window.themeSettings.allowNote) {      
  var checkInstructions = document.getElementById('chk-instructions');
  if (checkInstructions) {
    var checkInstructionsChange = function() {
      var note = document.getElementById('instructions-note');
      if (checkInstructions.checked) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkInstructions.click();
      }
    });
    checkInstructions.addEventListener('click', checkInstructionsChange);
    checkInstructionsChange();
  }
  }

  $s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));
  })();